export const LITERACY_INSIGHT_TOOLTIP_LINK_HREF =
  'https://sites.google.com/view/amplify-embedded-measurement/home';
